import { ServerMessageAttachment } from "../attachments/types";
import { ConversationTransferDestination } from "./commands";
import { Sender } from "./common";
import { Conversation, ConversationStatus } from "./queries";

export enum MessagingEventType {
  NEW_CONVERSATION = "NEW_CONVERSATION",
  NEW_CONVERSATION_MESSAGE = "NEW_CONVERSATION_MESSAGE",
  CONVERSATION_MESSAGE_ATTACHMENTS_UPDATED = "CONVERSATION_MESSAGE_ATTACHMENTS_UPDATED",
  CONVERSATION_STATUS_UPDATED = "CONVERSATION_STATUS_UPDATED",
  CONVERSATION_ASSIGNED = "CONVERSATION_ASSIGNED",
  CONVERSATION_TRANSFERRED = "CONVERSATION_TRANSFERRED",
  CONVERSATION_MESSAGES_READ = "CONVERSATION_MESSAGES_READ",
}

export enum MessagingEventSource {
  SRV_MESSAGING = "srv-messaging",
}

export interface SocketEvent<T> {
  id: string;
  type: MessagingEventType;
  source: MessagingEventSource;
  timestamp: string; // ISO format
  senderId: string;
  payload: T;
}

export interface NewConversationMessagePayload {
  id: string;
  conversationId: string;
  senderId: string;
  text: string;
  sentAt: string;
  sender: Sender;
}

export interface ConversationStatusUpdatedPayload {
  conversationId: string;
  status: ConversationStatus;
  updatedBy: string; // id?
}

export interface ConversationAssignedPayload {
  conversationId: string;
  participantId: string;
  assignedBy: string; // id?
}

export interface ConversationTransferredPayload {
  conversationId: string;
  destination: ConversationTransferDestination;
  transferredBy: string;
}

export interface ConversationMessageAttachmentsUpdatedPayload {
  conversationId: string;
  messageId: string;
  attachments: ServerMessageAttachment[];
}

export interface ConversationMessagesReadPayload {
  conversationId: string;
  readerId: string;
  lastReadMessageId: string;
}

export type MessagingEventPayload =
  | NewConversationMessagePayload
  | Conversation
  | ConversationStatusUpdatedPayload
  | ConversationAssignedPayload
  | ConversationTransferredPayload
  | ConversationMessageAttachmentsUpdatedPayload
  | ConversationMessagesReadPayload;
